<!--
  ~ VNCtalk - an enterprise real-time communication solution including chat, video and audio conferencing, screen sharing, voice messaging, file sharing, broadcasts, document collaboration and much more.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="common-dialog-component">
  <vnc-dialog [classes]="isMobileSize ? ['common-dialog', 'mobile-size'] : ['common-dialog']" [headerTemplate]="headerTemplate"
    [footerTemplate]="footerTemplate" [bodyTemplate]="bodyTemplate">
  </vnc-dialog>
  <ng-template #bodyTemplate>
    <div class="content-wrapper" style="height: calc(100% - 139px);" *ngIf="!isMobileSize">
      <vnc-input [form]="searchControl" [showClear]="true" [showLabel]="true"
        placeholder="{{'ENTER_USER_GROUP'|translate}}" size="l" [matAutocompleteTemplate]="chatUsersTemplate"
        type="text" clearTooltip="{{ 'CLEAR' | translate}}">
      </vnc-input>
      <ng-template #chatUsersTemplate>
        <mat-option *ngFor="let option of filteredOptions$ | async" class="chat-filter-item">
          <vp-dropdown-item (click)="selectUser(option)" [avatarFallback]="option" itemType="user-default" label="{{option.fullName}}"
            [imgSrc]="option.imgSrc" [isActive]="false">
          </vp-dropdown-item>
        </mat-option>
      </ng-template>
      <div class="users-and-groups vnc-scroll-bar--small--vertical">
        <ng-container *ngIf="!isMobileSize">
          <vp-dropdown-item [avatarFallback]="item" *ngFor="let item of selection.selected" itemType="user-default" label="{{item.fullName}}"
            [imgSrc]="item.imgSrc" [isActive]="false" (deleteIconClick)="removeUser(item)"
            size="l" [showDeleteIcon]="true">
          </vp-dropdown-item>
        </ng-container>

        <ng-container *ngIf="isMobileSize">
            <vnc-user-chip *ngFor="let user of selection.selected" (remove)="removeUser(user)" [removeable]="true" [clickable]="true" size="sm"
                [item]="user" [avatarTemplate]="avatarTemplate"></vnc-user-chip>
        </ng-container>

        <ng-template #avatarTemplate let-item="item">
            <vp-avatar size="custom" [jid]="item.email" [hidestatus]="true" *ngIf="item.shareType === 0"></vp-avatar>
            <svg width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg" *ngIf="item.shareType === 1">
              <path d="M7.151 5.429c.535 0 1.117.115 1.746.343.685.248 1.115.646 1.227 1.194l.015.088.004.059v.458a.429.429 0 0 1-.857 0v-.423l-.005-.022c-.048-.198-.228-.37-.59-.515l-.086-.033c-.54-.196-1.025-.292-1.454-.292-.231 0-.48.028-.747.085.147.174.246.372.291.595l.015.088.004.059V8a.429.429 0 0 1-.857 0v-.85l-.005-.024c-.044-.183-.2-.343-.509-.48l-.08-.035-.087-.033c-.54-.196-1.025-.292-1.453-.292-.429 0-.917.096-1.463.293-.425.152-.632.335-.684.547l-.005.022V8a.429.429 0 0 1-.857 0v-.887l.004-.06c.083-.593.525-1.02 1.252-1.281.634-.228 1.218-.343 1.753-.343.525 0 1.094.11 1.71.33l-.035.013c.635-.228 1.219-.343 1.753-.343zM3.5 2c.42 0 .785.143 1.07.426.285.283.43.647.43 1.066 0 .419-.145.783-.43 1.066-.28.278-.636.427-1.077.442a1.542 1.542 0 0 1-1.063-.442A1.456 1.456 0 0 1 2 3.492c0-.42.145-.783.43-1.066C2.715 2.143 3.08 2 3.5 2zm3.857 0c.42 0 .785.143 1.07.426.285.283.43.647.43 1.066 0 .419-.145.783-.43 1.066-.282.279-.643.427-1.094.442a1.522 1.522 0 0 1-1.045-.442 1.456 1.456 0 0 1-.43-1.066c0-.42.144-.783.43-1.066.284-.283.65-.426 1.07-.426zM3.5 2.857a.619.619 0 0 0-.466.177.602.602 0 0 0-.177.458c0 .195.057.338.177.457a.67.67 0 0 0 .459.194.668.668 0 0 0 .473-.194.602.602 0 0 0 .177-.457.602.602 0 0 0-.177-.458.619.619 0 0 0-.466-.177zm3.857 0a.619.619 0 0 0-.466.177.602.602 0 0 0-.177.458c0 .195.058.338.177.457a.652.652 0 0 0 .443.194.69.69 0 0 0 .489-.194A.602.602 0 0 0 8 3.492a.602.602 0 0 0-.177-.458.619.619 0 0 0-.466-.177z" fill="#FFF" fill-rule="evenodd"></path>
            </svg>
        </ng-template>
      </div>

    </div>
    <div class="content-wrapper" style="height: calc(100% - 300px);" *ngIf="isMobileSize">
      <vnc-input [form]="searchControl" [showClear]="true" [showLabel]="true"
        placeholder="{{'ENTER_USER_GROUP'|translate}}" size="l" [matAutocompleteTemplate]="chatUsersTemplate"
        type="text" clearTooltip="{{ 'CLEAR' | translate}}">
      </vnc-input>
      <ng-template #chatUsersTemplate>
        <mat-option *ngFor="let option of filteredOptions$ | async" class="chat-filter-item">
          <vp-dropdown-item (click)="selectUser(option)" [avatarFallback]="option" itemType="user-default" [label]="option.fullName"
           [imgSrc]="option.imgSrc"></vp-dropdown-item>
        </mat-option>
      </ng-template>
      <div class="users-and-groups vnc-scroll-bar--small--vertical">
        <ng-container *ngIf="!isMobileSize">
          <vp-dropdown-item [avatarFallback]="item" *ngFor="let item of selection.selected" itemType="user-default" label="{{item.fullName}}"
            [imgSrc]="item.imgSrc" [isActive]="false" (deleteIconClick)="removeUser(item)"
            size="l" [showDeleteIcon]="true">
          </vp-dropdown-item>
        </ng-container>

        <ng-container *ngIf="isMobileSize">
            <vnc-user-chip *ngFor="let user of selection.selected" (remove)="removeUser(user)" [removeable]="true" [clickable]="true" size="sm"
                [item]="user" [avatarTemplate]="avatarTemplate"></vnc-user-chip>
        </ng-container>

        <ng-template #avatarTemplate let-item="item">
            <vp-avatar size="custom" [jid]="item.email" [hidestatus]="true" *ngIf="item.shareType === 0"></vp-avatar>
            <svg width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg" *ngIf="item.shareType === 1">
              <path d="M7.151 5.429c.535 0 1.117.115 1.746.343.685.248 1.115.646 1.227 1.194l.015.088.004.059v.458a.429.429 0 0 1-.857 0v-.423l-.005-.022c-.048-.198-.228-.37-.59-.515l-.086-.033c-.54-.196-1.025-.292-1.454-.292-.231 0-.48.028-.747.085.147.174.246.372.291.595l.015.088.004.059V8a.429.429 0 0 1-.857 0v-.85l-.005-.024c-.044-.183-.2-.343-.509-.48l-.08-.035-.087-.033c-.54-.196-1.025-.292-1.453-.292-.429 0-.917.096-1.463.293-.425.152-.632.335-.684.547l-.005.022V8a.429.429 0 0 1-.857 0v-.887l.004-.06c.083-.593.525-1.02 1.252-1.281.634-.228 1.218-.343 1.753-.343.525 0 1.094.11 1.71.33l-.035.013c.635-.228 1.219-.343 1.753-.343zM3.5 2c.42 0 .785.143 1.07.426.285.283.43.647.43 1.066 0 .419-.145.783-.43 1.066-.28.278-.636.427-1.077.442a1.542 1.542 0 0 1-1.063-.442A1.456 1.456 0 0 1 2 3.492c0-.42.145-.783.43-1.066C2.715 2.143 3.08 2 3.5 2zm3.857 0c.42 0 .785.143 1.07.426.285.283.43.647.43 1.066 0 .419-.145.783-.43 1.066-.282.279-.643.427-1.094.442a1.522 1.522 0 0 1-1.045-.442 1.456 1.456 0 0 1-.43-1.066c0-.42.144-.783.43-1.066.284-.283.65-.426 1.07-.426zM3.5 2.857a.619.619 0 0 0-.466.177.602.602 0 0 0-.177.458c0 .195.057.338.177.457a.67.67 0 0 0 .459.194.668.668 0 0 0 .473-.194.602.602 0 0 0 .177-.457.602.602 0 0 0-.177-.458.619.619 0 0 0-.466-.177zm3.857 0a.619.619 0 0 0-.466.177.602.602 0 0 0-.177.458c0 .195.058.338.177.457a.652.652 0 0 0 .443.194.69.69 0 0 0 .489-.194A.602.602 0 0 0 8 3.492a.602.602 0 0 0-.177-.458.619.619 0 0 0-.466-.177z" fill="#FFF" fill-rule="evenodd"></path>
            </svg>
        </ng-template>
      </div>

    </div>
    <div>
      {{ 'PERMISSIONS' | translate }}
    </div>
        <ng-container *ngIf="!isMobileSize">
          <mat-radio-group [(ngModel)]="permission">
            <div class="permission-option" *ngIf="file.type === 'dir'">
              <mat-radio-button value="31">{{ 'PERM_READ_CREATE_SHARE_DELETE' | translate}}</mat-radio-button>
            </div>
            <div class="permission-option" *ngIf="file.type === 'dir'">
              <mat-radio-button value="23">{{ 'PERM_READ_CREATE_SHARE' | translate}}</mat-radio-button>
            </div>
            <div class="permission-option" *ngIf="file.type === 'dir'">
              <mat-radio-button value="7">{{ 'PERM_READ_CREATE' | translate}}</mat-radio-button>
            </div>
            <div class="permission-option" *ngIf="file.type === 'file'">
              <mat-radio-button value="19">{{ 'PERM_READ_EDIT_SHARE' | translate}}</mat-radio-button>
            </div>
            <div class="permission-option" *ngIf="file.type === 'file'">
              <mat-radio-button value="3">{{ 'PERM_READ_EDIT' | translate}}</mat-radio-button>
            </div>
            <div class="permission-option">
              <mat-radio-button value="1">{{ 'PERM_READ_ONLY' | translate}}</mat-radio-button>
            </div>

          </mat-radio-group>
        </ng-container>
        <ng-container *ngIf="isMobileSize">
            <div class="permission-option" *ngIf="file.type === 'dir'">
              <vp-dropdown-item (onClickEvent)="permission = '31'" itemType="filter-check-unchecked" label="{{ 'PERM_READ_CREATE_SHARE_DELETE' | translate}}" [isActive]="permission === '31'" [isSelectOption]="true"></vp-dropdown-item>
            </div>
            <div class="permission-option" *ngIf="file.type === 'dir'">
              <vp-dropdown-item (onClickEvent)="permission = '23'" itemType="filter-check-unchecked" label="{{ 'PERM_READ_CREATE_SHARE' | translate}}" [isActive]="permission === '23'" [isSelectOption]="true"></vp-dropdown-item>
            </div>
            <div class="permission-option" *ngIf="file.type === 'dir'">
              <vp-dropdown-item (onClickEvent)="permission = '7'" itemType="filter-check-unchecked" label="{{ 'PERM_READ_CREATE' | translate}}" [isActive]="permission === '7'" [isSelectOption]="true"></vp-dropdown-item>
            </div>
            <div class="permission-option" *ngIf="file.type === 'file'">
              <vp-dropdown-item (onClickEvent)="permission = '19'" itemType="filter-check-unchecked" label="{{ 'PERM_READ_EDIT_SHARE' | translate}}" [isActive]="permission === '19'" [isSelectOption]="true"></vp-dropdown-item>
            </div>
            <div class="permission-option" *ngIf="file.type === 'file'">
              <vp-dropdown-item (onClickEvent)="permission = '3'" itemType="filter-check-unchecked" label="{{ 'PERM_READ_EDIT' | translate}}" [isActive]="permission === '19'" [isSelectOption]="true"></vp-dropdown-item>
            </div>
            <div class="permission-option">
              <vp-dropdown-item (onClickEvent)="permission = '1'" itemType="filter-check-unchecked" label="{{ 'PERM_READ_ONLY' | translate}}" [isActive]="permission === '1'" [isSelectOption]="true"></vp-dropdown-item>
            </div>
        </ng-container>

  </ng-template>

  <ng-template #headerTemplate>
    <vnc-header *ngIf="!isMobileSize" style="width:100%;" title="{{ 'SHARE_WITH_USERS_AND_GROUPS' | translate }}" type="title-close" size="l"
      (onCloseClick)="cancel()" [showCloseIcon]="true" closeIconToolTip="{{ 'CLOSE' | translate }}">
    </vnc-header>
    <vnc-mobile-header *ngIf="isMobileSize" style="width: 100%" (darkSuffixButtonPress)="share()" (darkBackPress)="cancel()" darkSuffixIcon="mdi-check" headerType="dark-back-more" darkBackMorePlaceHolder="{{ 'SHARE_WITH_USERS_AND_GROUPS' | translate }}"></vnc-mobile-header>

  </ng-template>
  <ng-template #footerTemplate>
    <vnc-footer *ngIf="!isMobileSize" secondaryLabel="{{ 'CANCEL' | translate }}" primaryLabel="{{ 'SHARE' | translate }}"
      (onPrimaryClick)="share()" (onSecondaryClick)="cancel()" [type]="'secondary-primary'" [color]="'white'">
    </vnc-footer>
  </ng-template>
</div>
